<template>
  <account-verify-code-connector
    v-if="account.auth_method === 'verify_code'"
    :account="account"
    :connection="connection"
    @onConnectedStart="$emit('onConnectedStart')"
    @onAccountConnected="$emit('onAccountConnected')"
  />
  <account-qr-code-connector
    v-else-if="account.auth_method === 'qr_code'"
    :account="account"
    :connection="connection"
    @onConnectedStart="$emit('onConnectedStart')"
    @onAccountConnected="$emit('onAccountConnected')"
    @onQrError="$emit('onQrError')"
  />
</template>

<script>

import AccountVerifyCodeConnector from './AccountVerifyCodeConnector.vue'
import AccountQrCodeConnector from './AccountQrCodeConnector.vue'

export default {
  name: 'AccountConnector',
  components: {
    AccountQrCodeConnector,
    AccountVerifyCodeConnector,
  },
  props: {
    account: {
      type: Object,
      default: () => {},
    },
    connection: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style scoped>

</style>
